import { Box, Grid, Typography } from "@mui/material";
import { Button, Toolbar, useNotify, useRecordContext } from "react-admin";
import { useAppDataContext } from "../../framework/app/app.data.context";
import { useState } from "react";

import { useMutation } from "react-query";
import { getConfig } from "../../framework/config/app.config";

const CustomToolbar = (props) => {
  const csApiUrl = getConfig('VITE_BASE_URL');
  const notify = useNotify();
  const { appContext } = useAppDataContext();
  const { httpClient } = appContext || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const tenantId: string = sessionStorage.getItem("current-tenant");
  const url = `${csApiUrl}/restaurant-tenant/synchronize`;

  // Define the custom API call using mutation
  const mutation = useMutation(
    () => {
      return httpClient(`${url}`, {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
        }),
      });
    },
    {
      onSuccess: () => {
        notify("API called successfully!", { type: "success" });
      },
      onError: () => {
        notify("API call failed", { type: "error" });
      },
    }
  );

  const handleClick = () => {
    setIsSubmitting(true);
    mutation.mutate();
    setIsSubmitting(false);
  };

  return (
    <Toolbar {...props}>
      <Button
        label="Synthesize Data"
        onClick={handleClick}
        disabled={isSubmitting}
      />
    </Toolbar>
  );
};

export const Synthesize = () => {
  let PRODUCT: string = getConfig("VITE_APP_PRODUCT");
  PRODUCT = PRODUCT.charAt(0).toUpperCase() + PRODUCT.slice(1);

  return (
    <Box sx={{ width: "100%", marginTop: "20px" }}>
      <Grid container spacing={2}>

        <Grid item xs={12}>
          <Box sx={{ padding: "14px" }}>
            <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
              {`${PRODUCT} AI uses includes the ability to synthesize locations, employees, customers, engagement and transactions.`}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <CustomToolbar />
        </Grid>

      
      </Grid>
    </Box>
  );
};
